export default __webpack_public_path__ + "static/media/consumption-rpm.611916ae.svg";